import { useEffect, useState } from "react";

/**
 * QR code as inline SVG. Always dark modules on a white tile, in both themes, because many
 * exchange-app scanners fail on inverted codes.
 */
export function QrCode({ value, label, size = 188 }: { value: string; label: string; size?: number }) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    // Loaded on demand: only the exchange tab needs it.
    import("qrcode")
      .then(({ default: QRCode }) => QRCode.toString(value, { type: "svg", errorCorrectionLevel: "M", margin: 0, color: { dark: "#0B0D12", light: "#FFFFFF" } }))
      .then((out) => {
        if (!cancelled) setSvg(out);
      })
      .catch(() => {
        if (!cancelled) setSvg(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  return (
    <div className="qr" style={{ width: size + 28, height: size + 28 }} role="img" aria-label={label}>
      {svg ? (
        // The markup is generated locally by the qrcode library from our own value: paths only.
        <div className="qr-svg" style={{ width: size, height: size }} dangerouslySetInnerHTML={{ __html: svg }} />
      ) : (
        <div className="qr-svg skeleton" style={{ width: size, height: size }} />
      )}
    </div>
  );
}
